import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "s20 items-center gap-6 px-0 pb-6 collapse-content active" }
const _hoisted_2 = { class: "px-5 mt-3" }
const _hoisted_3 = { class: "s10" }
const _hoisted_4 = { class: "secondary-font gap-4 mt-2 mb-4" }
const _hoisted_5 = { class: "s10 font-medium pl-8" }
const _hoisted_6 = { class: "text-4xl font-bold ml-2" }
const _hoisted_7 = { class: "s10 form-field-split my-4" }
const _hoisted_8 = { class: "form-field-floating lg active half" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-field-floating lg reactive half" }
const _hoisted_12 = { class: "s10_mobile pl-8" }
const _hoisted_13 = { class: "custom-upload-st2" }
const _hoisted_14 = { class: "s12" }
const _hoisted_15 = {
  id: "file-upload-title",
  class: "custom-upload-text"
}
const _hoisted_16 = {
  id: "file-upload-title",
  class: "custom-upload-text"
}
const _hoisted_17 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_18 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_19 = { class: "text-3xl font-bold position-absolute" }
const _hoisted_20 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","justify-content":"end"}
}
const _hoisted_21 = {
  key: 0,
  class: "text-red"
}
const _hoisted_22 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between","margin-bottom":"10px"} }
const _hoisted_23 = { class: "text-red" }
const _hoisted_24 = { class: "table separator skin1" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  colspan: "9",
  class: "text-center py-5"
}
const _hoisted_27 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "font-bold text-xl" }
const _hoisted_30 = { class: "font-bold text-xl" }
const _hoisted_31 = { class: "font-bold" }
const _hoisted_32 = { class: "text-sm text-grey-500" }
const _hoisted_33 = { class: "text-sm text-grey-500" }
const _hoisted_34 = { class: "text-sm text-grey-500" }
const _hoisted_35 = { class: "tag-state warning stroke" }
const _hoisted_36 = { class: "flex-right" }
const _hoisted_37 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }

import { computed, reactive, ref, toRaw, watch } from 'vue';
    import { AMOUNT_FORMAT_CONFIG, formatAmount } from '@/utils';
    import axios from 'axios';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FinancePrelevementsForm',
  props: {
        startupInfos: { type: Object, default: null },
        isWidgetMode: { type: Boolean, default: true }
    },
  emits: ['updated'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const emit = __emit;
    const props = __props
    const queryParams = reactive({
        pageNumber: 1,
        sortDir: 'DESC',
        sortColumn: 'created_at',
        sortOption: 'created_at_desc',
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const itemsList = ref([] as any[]);
    const itemsPaginated = ref([] as any[]);
    const errorMessage = ref('');
    const errorMessageValidationPrelevement = ref('');
    const loading = ref(false);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const loadingValidationPrelevement = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        periode: null as any | null,
        montant_prelevement: 0,
        file: null as File | null,
        file_name: '',
        file_preview: null as any,
    });
    const errors = reactive({
        montant_prelevement: "",
        file_name: ""
    });
    const periodes_options = ref([] as any[]);
    const collectivite = ref(null as any);
    const statsInfos = ref({
        montant_prelevement_expected: 0,
    });

    watch(() => props.startupInfos, (newVal: any) => {
        const isFirstChanged = !collectivite.value;
        if (newVal) {
            collectivite.value = newVal.collectivite;
            periodes_options.value = newVal.periodes;
            formData.periode = newVal.periodes.find((p: any) => p.selected == true);
            if (!formData.periode) {
                formData.periode = newVal.periodes.length > 0 ? { value: newVal.periodes[0].value, label: newVal.periodes[0].label } : null;
            }
        }
        if (isFirstChanged) {
            doGetPrelevementDetailsInfos();
        }
    }, { immediate: true });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });
    const prelevement_percentage = computed(() => {
        return formData.montant_prelevement && statsInfos.value.montant_prelevement_expected
            ? Math.min(100, (formData.montant_prelevement / statsInfos.value.montant_prelevement_expected) * 100).toFixed(0)
            : 0;
    });

    function validate() {
        let isValid = true;

        errors.montant_prelevement = '';
        if (!formData.montant_prelevement || formData.montant_prelevement <= 0) {
            errors.montant_prelevement ="Le montant est requis";
            isValid = false;
        }

        errors.file_name = '';
        if (!formData.file_name) {
            errors.file_name ="Le fichier est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function doGetPrelevementDetailsInfos() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const queryParamsRaw = {
                periode: formData.periode?.value || '',
            };
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/finance/prelevements/get_prelevements_infos/${collectivite.value.id}?${queryString}`);

            statsInfos.value.montant_prelevement_expected = httpResponse.data.montant_prelevement_expected;

            itemsList.value = httpResponse.data.prelevements;
            pagination.total = itemsList.value.length;
            pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
            onPaginate(queryParams.pageNumber);
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function onSelectPeriode(event: any) {
        const selectedValue = event.target.value;
        const selectedOption = periodes_options.value.find(option => option.value === selectedValue);
        formData.periode = selectedOption || null;
        doGetPrelevementDetailsInfos();
    }

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formData.file = event.target.files[0];
                formData.file_name = event.target.files[0].name;
                formData.file_preview = e.target!.result as string;
                event.target.value = null;
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw({ ...queryParams,
                periode: formData.periode.value || '',
            });
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/finance/prelevements/list_prelevements/${collectivite.value.id}?${queryString}`);
            itemsList.value = httpResponse.data;
            pagination.total = itemsList.value.length;
            pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
            onPaginate(queryParams.pageNumber);
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }
    
    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        const startIndex = (queryParams.pageNumber - 1) * pagination.per_page;
        const endIndex = startIndex + pagination.per_page;
        itemsPaginated.value = itemsList.value.slice(startIndex, endIndex);
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = new FormData();
            formToUpload.append("collectivite_id", collectivite.value.id.toString());
            formToUpload.append("periode_prelevement", formData.periode.value);
            formToUpload.append("montant_prelevement", formData.montant_prelevement.toString());
            formToUpload.append("fichier_prelevement", formData.file!, formData.file!.name);
            await axios.post(`/backoffice/finance/prelevements/save_prelevement/${collectivite.value.id}`, formToUpload);
            emit('updated');
            resetForm();
            doListItems();
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    function resetForm() {
        formData.montant_prelevement = 0;
        formData.file = null;
        formData.file_name = '';
        formData.file_preview = null;
        isFormValid.value = false;
        errorMessage.value = '';
    }   

    async function doValidatePrelevement(prelevement: any) {
        const confirmation = await confirmationModalRef.value?.open("Prélèvemenets", "Voulez-vous vraiment valider l'élément sélectionné ?");
        if (confirmation) {
            try {
                loadingValidationPrelevement.value = true;
                errorMessageValidationPrelevement.value = '';
                const httpResponse = await axios.post(`/backoffice/finance/prelevements/validate_prelevement/${collectivite.value.id}`, { prelevement_id: prelevement.id });
                emit('updated', httpResponse.data);
                doListItems();
            } catch(error: any) {
                errorMessageValidationPrelevement.value = error.message;
                console.error(error);
            } finally {
                loadingValidationPrelevement.value = false;
            }
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["s20 px-6 pt-8 pb-2", {'widget': __props.isWidgetMode}])
    }, [
      _cache[28] || (_cache[28] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Gérer les prélèvements </span></div><div class=\"clear-both h-5\"></div>", 2)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, " Charger le fichier de prélèvement de " + _toDisplayString(formData.periode ? formData.periode.label : ''), 1),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mb-2" }, "Format de fichier supporté: PDF. Taille max: 50MB.", -1))
          ]),
          _createElementVNode("h2", _hoisted_5, [
            _cache[4] || (_cache[4] = _createTextVNode(" Montant à récevoir ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(formatAmount)(statsInfos.value.montant_prelevement_expected)) + " F CFA", 1)
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("select", {
                class: "form-input-select",
                name: "pays",
                id: "pays",
                value: formData.periode?.value,
                onChange: onSelectPeriode
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodes_options.value, (periode) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: periode.value,
                    key: periode.value
                  }, _toDisplayString(periode.label), 9, _hoisted_10))
                }), 128))
              ], 40, _hoisted_9),
              _cache[6] || (_cache[6] = _createElementVNode("label", { for: "pays" }, [
                _createTextVNode("Sélectionner une période "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "hr" }, null, -1)),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_money3, _mergeProps({
                class: "form-input",
                modelValue: formData.montant_prelevement,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.montant_prelevement) = $event)),
                name: "montant",
                id: "montant",
                placeholder: ""
              }, _unref(AMOUNT_FORMAT_CONFIG)), null, 16, ["modelValue"]),
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "montant" }, "Montant du virement", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "" }, "F CFA", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", {
              for: "file-prelevement",
              class: _normalizeClass(["mt-4 custom-upload", {'active': formData.file}])
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("input", {
                  id: "file-prelevement",
                  class: "display-none",
                  type: "file",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (onFileUploaded($event))),
                  accept: ".pdf"
                }, null, 32),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "s4 custom-upload-img" }, ".PDF", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(formData.file_name ? formData.file_name : 'Charger le fichier'), 1),
                  _cache[10] || (_cache[10] = _createTextVNode()),
                  _cache[11] || (_cache[11] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(formData.file_name ? 'Doc chargé' : 'Uploader le doc'), 1)
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "s4 right" }, [
                  _createElementVNode("img", {
                    src: "/icons/icon-upload.svg",
                    class: "custom-upload-icon"
                  })
                ], -1))
              ])
            ], 2)
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(prelevement_percentage.value) + "%", 1),
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-yellow",
              style: _normalizeStyle({'width': prelevement_percentage.value + '%'})
            }, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(formatAmount)(formData.montant_prelevement)) + " F / " + _toDisplayString(_unref(formatAmount)(statsInfos.value.montant_prelevement_expected)) + " F", 1)
            ], 4)
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
          (isFormValid.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (!!errorMessage.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(errorMessage.value), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_custom_button, {
                  type: "button",
                  classesList: 'btn lg py-5 black',
                  loading: loading.value,
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("span", null, "Télécharger le fichier de prélèvement", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]))
            : _createCommentVNode("", true),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, _toDisplayString(errorMessageValidationPrelevement.value), 1),
          _createElementVNode("button", {
            onClick: doListItems,
            class: "btn black normal justify-content-center mx-0 btn-filtre"
          }, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("img", {
              src: "/icons/icon-scan.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Actualiser", -1)
          ]))])
        ]),
        _createElementVNode("table", _hoisted_24, [
          _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "selection-item" }, [
                _createElementVNode("label", {
                  class: "btn-circle",
                  for: "check-list1"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    name: "check-list",
                    id: "check-list1"
                  })
                ])
              ]),
              _createElementVNode("th"),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Période ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-down.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Montant")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-down.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Fichier")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Date")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Effectué par")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Etat")
              ]),
              _createElementVNode("th")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                  _createElementVNode("td", _hoisted_26, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("div", { class: "loader dark" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (itemsList.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("td", {
                      colspan: "9",
                      class: "text-center py-5"
                    }, " Aucune fichier de prélèvement trouvée. ", -1)
                  ]))]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(itemsList.value, (prelevement, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "text-grey-700 over-effect",
                      key: 'prelevement_' + index
                    }, [
                      _cache[25] || (_cache[25] = _createElementVNode("td", { class: "selection-item" }, [
                        _createElementVNode("label", {
                          class: "btn-circle",
                          for: "check-list1"
                        }, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            name: "check-list",
                            id: "check-list1"
                          })
                        ])
                      ], -1)),
                      _cache[26] || (_cache[26] = _createElementVNode("td", { class: "font-black" }, [
                        _createElementVNode("img", {
                          src: "/icons/icon-data.svg",
                          class: "size-medium"
                        })
                      ], -1)),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(prelevement.periode_prelevement_formatted), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(formatAmount)(prelevement.montant_prelevement)) + " F CFA", 1),
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("a", null, _toDisplayString(prelevement.fichier_prelevement), 1)
                      ]),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(prelevement.created_at_formatted), 1),
                      _createElementVNode("td", _hoisted_33, [
                        _createTextVNode(_toDisplayString(prelevement.admin.username) + " ", 1),
                        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(prelevement.admin.email), 1)
                      ]),
                      _createElementVNode("td", _hoisted_34, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(prelevement.status_prelevement_label), 1)
                      ]),
                      _createElementVNode("td", _hoisted_36, [
                        (prelevement.status_prelevement == 'pending')
                          ? (_openBlock(), _createBlock(_component_custom_button, {
                              key: 0,
                              type: "button",
                              onClick: ($event: any) => (doValidatePrelevement(prelevement)),
                              classesList: 'btn-ultra',
                              loading: loadingValidationPrelevement.value
                            }, {
                              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                _createElementVNode("img", {
                                  src: "/icons/icon-valider.svg",
                                  class: "btn-icon",
                                  alt: ""
                                }, null, -1),
                                _createElementVNode("span", null, "Valider", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick", "loading"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_custom_pagination, {
            modelValue: queryParams.pageNumber,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((queryParams.pageNumber) = $event)),
              onPaginate
            ],
            total: pagination.total,
            "per-page": pagination.per_page,
            last_page: pagination.last_page
          }, null, 8, ["modelValue", "total", "per-page", "last_page"])
        ])
      ])
    ], 2),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ], 64))
}
}

})